import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowCornerRightDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowCornerRightDown"><Path fillRule="evenodd" clipRule="evenodd" d="M15.25 21.2501L20.3107 16.1895L19.25 15.1288L16 18.3788V2.93945H4V4.43945H14.5V18.3788L11.25 15.1288L10.1893 16.1895L15.25 21.2501Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowCornerRightDown;
